export default __webpack_public_path__ + "static/media/image.da881b12.png";